import { Box } from "@mui/material";
import useSelectedPatient from "../../../../../../../hooks/local-storage/use-selected-patient";
import Tasks from "../../../../collabration/tasks/Tasks";

const PatientTask = () => {
  const patientData = useTaskPatientDataByCurrentPatient();

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Tasks tableHeight="95%" patientData={patientData} />
    </Box>
  );
};

export default PatientTask;

const useTaskPatientDataByCurrentPatient = () => {
  const [selectedPatient] = useSelectedPatient();

  const patientName = `${selectedPatient?.firstName} ${selectedPatient?.lastName}`;

  const patientData = {
    label: patientName,
    value: selectedPatient?.uuid,
  };

  return patientData;
};
